<template>
  <ScheduleDialog
    :open="open"
    title="Baixar lista de agendamentos"
    @close="close"
  >
    <div class="sw-print">
      <label class="sw-print__field">
        Data de início
        <input
          v-model="start"
          type="date"
          class="form-control form-control-solid"
        >
      </label>
      <label class="sw-print__field">
        Data de fim
        <input
          v-model="end"
          type="date"
          class="form-control form-control-solid"
        >
      </label>
      <div class="sw-print__field">
        <span>Agrupar por</span>
        <SelectUbbi
          v-model="groupBy"
          :options="groupOptions"
          option-label="label"
          option-value="value"
        />
      </div>
      <p v-if="error" class="sw-print__error">{{ error }}</p>
    </div>
    <template #footer>
      <button type="button" class="sw-print__btn" :disabled="loading" @click="close">Fechar</button>
      <button type="button" class="sw-print__btn is-primary" :disabled="loading" @click="submit">
        {{ loading ? 'Gerando…' : 'Imprimir' }}
      </button>
    </template>
  </ScheduleDialog>
</template>

<script>
import SelectUbbi from '../../../components/SelectUbbi.vue';
import { downloadScheduleListPdf } from '../../../helpers/printScheduleList';
import ScheduleDialog from './ScheduleDialog.vue';

export default {
  name: 'SchedulePrintListModal',
  components: { ScheduleDialog, SelectUbbi },
  props: {
    open: { type: Boolean, default: false },
    placeId: { default: null },
    idProf: { default: null },
    idSpec: { default: null },
    startDate: { type: String, default: '' },
    endDate: { type: String, default: '' },
  },
  emits: ['close'],
  data() {
    return {
      start: '',
      end: '',
      groupBy: 'ESPEC',
      error: '',
      loading: false,
      groupOptions: [
        { value: 'ESPEC', label: 'Especialidade' },
        { value: 'PROF', label: 'Profissional' },
      ],
    };
  },
  watch: {
    open(value) {
      if (!value) return;
      this.start = this.startDate;
      this.end = this.endDate;
      this.groupBy = 'ESPEC';
      this.error = '';
      this.loading = false;
    },
  },
  methods: {
    close() {
      if (this.loading) return;
      this.$emit('close');
    },
    submit() {
      if (!this.start || !this.end) {
        this.error = 'Selecione a data de início e a data de fim.';
        return;
      }
      if (this.start > this.end) {
        this.error = 'A data de início não pode ser depois da data de fim.';
        return;
      }
      this.error = '';
      this.loading = true;
      downloadScheduleListPdf({
        placeId: this.placeId,
        idProf: this.idProf,
        idSpec: this.idSpec,
        start: this.start,
        end: this.end,
        groupBy: this.groupBy,
      }).then(() => {
        this.loading = false;
        this.$emit('close');
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.sw-print {
  display: grid;
  gap: 0.75rem;
}
.sw-print__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin: 0;
  font-size: 0.75rem;
  font-weight: 700;
  color: #7e8299;
}
.sw-print__field .form-control {
  min-height: 2.35rem;
  font-size: 0.88rem;
}
.sw-print__error {
  margin: 0;
  color: #f1416c;
  font-size: 0.8rem;
  font-weight: 600;
}
.sw-print__btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.4rem;
  margin: 0;
  padding: 0.45rem 0.95rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.5rem;
  background: #fff;
  color: #181c32;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;
  box-shadow: none;
  cursor: pointer;
}
.sw-print__btn:hover:not(:disabled) {
  border-color: #780f5a;
  color: #780f5a;
}
.sw-print__btn.is-primary {
  background: #780f5a;
  border-color: #780f5a;
  color: #fff;
}
.sw-print__btn.is-primary:hover:not(:disabled) {
  background: #65104c;
  border-color: #65104c;
  color: #fff;
}
.sw-print__btn:disabled {
  opacity: 0.65;
  cursor: default;
}
</style>
